import React, { useEffect, useRef, useState } from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import TimeAgo from '../TimeAgo.jsx'

const ManageTabs = styled(Tabs)({
	minHeight: '85px',
	height: '85px',
	borderBottom: 0,
	'& .MuiTabs-indicator': {
	  backgroundColor: '#004753',
	},
});

  
const ManageTab = styled((props) => <Tab disableRipple {...props} />)(({ theme }) => ({
	minHeight: '42.5px',
	height: '42.5px',
	fontSize: '1rem',
	textTransform: 'none',
	margin: 0,
	minWidth: 0,
	[theme.breakpoints.up('sm')]: {
	  minWidth: 0,
	},
	color: '#e8e8e8',
	'&:hover': {
	  color: '#004753',
	  opacity: 1,
	},
	'&.Mui-selected': {
	  color: '#004753',
	  outline: 'none'
	},
	'&.Mui-focusVisible': {
	  backgroundColor: '#e8e8e8'
	},
}));

const TachesDiv = styled('div')({
	overflow: 'auto',
	height: '54px',
  });

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
		className="w-100"
		role="tabpanel"
		hidden={value !== index}
		id={`vertical-tabpanel-${index}`}
		aria-labelledby={`vertical-tab-${index}`}
		{...other}
    >
      {value === index && (
        <Box sx={{width: '100%'}}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

export default function CardTasksNotes({
	id,
	task,
	note,
	type = 'requests_hotels',
	from = 'accommodation'
}){
	const mounted = useRef();

	useEffect(() => {
		if (!mounted.current) {
			mounted.current = true;
		} else {
			initPartLink('#task_link_'+id);
		}
	});

	const [value, setValue] = useState(0);

	const handleChange = (event, newValue) => {
	  setValue(newValue);
	};

	return (
		<Box
			sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex', height: '85px', borderRadius: '0.38rem' }}
		>
			<ManageTabs
				orientation="vertical"
				value={value}
				onChange={handleChange}
				aria-label="Manage request hotel tabs"
				sx={{ borderRight: 1, borderColor: 'divider' }}
			>
				<ManageTab label={
					<span>
						<i className="fa-regular fa-list-check"></i>
						{task?.date_notified && <span className="badge badge-top badge-pill badge-gc-orange" style={{position: 'absolute', top: '5px', right: '5px', height: '15px', width: '15px', padding:0, paddingTop:3, paddingLeft:0, margin:0, fontSize:'10px'}}>{task?.total_tasks}</span>}
					</span>
					} 
					{...a11yProps(0)} 
				/>
				<ManageTab label={
					<span>
						<i className="fa-regular fa-clipboard"></i> 
						{note && <span className="badge badge-top badge-pill badge-gc-orange" style={{position: 'absolute', top: '5px', right: '5px', height: '15px', width: '15px', padding:0, margin:0, paddingTop:3, paddingLeft:0, fontSize:'10px'}}>1</span>}
					</span>
					} 
					{...a11yProps(1)} 
				/>
			</ManageTabs>
			<TabPanel value={value} index={0} sx={{ padding: 0 }}>
				<a
					href="#"
					data-part="+"
					data-target={type == 'requests_hotels' ? ('providers//tasks_controller/dispatch/requests_hotels/' + id) : ('providers//tasks_controller/dispatch/requests/' + id)}
					className="js-nav get_part_link"
					id={"task_link_" + id}
				>
					<div className="card border-none bg-white text-gc-dark-blue px-3 py-2">
						{task?.date_notified ?
							<div className='w-100'>
								<div 
									className="row border-bottom pb-2" 
									style={{lineHeight: '.8rem'}}
								>
									<div className="col-8 text-truncate">
										<span className="small font-weight-bold">
											{task?.surname} {task?.name}
										</span>
									</div>
									<div className="col-4 text-right text-truncate">
										{new Date(task?.date_notified).getTime() > new Date().getTime() ?
											<span className="small font-weight-bold">
												<TimeAgo date={task?.date_notified} lang={ENV.lang}/>
											</span>	
											:
											<span className="small font-weight-bold text-gc-orange">
												<TimeAgo date={task?.date_notified} lang={ENV.lang}/>
											</span>	
										}
									</div>
								</div>
								<TachesDiv className='thm-scroll-primary'>
									<p className="font-weight-normal m-0 py-2" style={{lineHeight: '1rem'}}>
										{task?.text.truncate(50)}
									</p>
								</TachesDiv>
							</div>
							:
							<div className="d-flex align-items-center m-auto" >
								<span className="d-block h6 font-weight-bold m-0" style={{lineHeight: '1rem'}}>
									{'add_task'.trad()}
								</span>
							</div>
						}
					</div>
				</a>
			</TabPanel>
			<TabPanel value={value} index={1} sx={{ padding: 0 }}>
				<a 
					href="#"
					data-part="+"
					data-target={type == 'requests_hotels' ? ('providers//requests_hotels/manage_infos/' + id) : ('providers/gps_requests//' + from + '/manage/' + id)}
					className="js-nav get_part_link"
				>
					<div className="card border-none bg-white text-gc-dark-blue px-3 py-2">
						{
							note ?
							<div className="d-flex align-items-center my-auto">
								<p className="font-weight-normal m-0" style={{lineHeight: '1rem'}}>
									{note?.truncate(70)}
								</p>
							</div>
							:
							<div className="d-flex align-items-center m-auto">
								<span className="d-block h6 font-weight-bold m-0" style={{lineHeight: '1rem'}}>{'add_note'.trad()}</span>
							</div>
						}
					</div>
				</a>
			</TabPanel>
		</Box>
	);
}